import { useAuth } from 'contexts/AuthContext';

// Server-driven admin gate. The backend (`findByUserId` →
// requirePlatformAdmin source-of-truth) stamps `is_platform_admin`
// onto the user object. The frontend has no business knowing the
// admin email — that would couple the CRA bundle to a backend
// config value and force a frontend rebuild every time the admin
// email rotates.
export default function usePlatformAdmin() {
  const { user } = useAuth();
  return user?.is_platform_admin === true;
}
